import React from "react";
import PropTypes from 'prop-types';
import { makeStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CircularProgress from "@mui/material/CircularProgress";
import { Button } from "@mui/material";


const useStyles = makeStyles(() => ({
  grow: {
    flexGrow: 1
  }
}));

const BottomBar = (props) => {

  const classes = useStyles();

  return (
    <div>
      <AppBar
        position="fixed"

        color="default"
        style={{
          top: "auto",
          bottom: 0,
          paddingLeft: props.isDrawerOpen ? 280 : 0
        }}

      >
        <Toolbar variant="dense">
          <Button
            variant="contained"
            onClick={() => props.leftButtonAction()}
            disabled={props.leftButtonDisable}
            style={{ display: props.leftButtonHide ? "none" : "block" }}>
            {props.leftButtonText}
          </Button>
          <div className={classes.grow} />

          <Button
            variant="contained"
            color="primary"
            disabled={props.isLoading || props.rightButtonDisable}
            onClick={() => props.rightButtonAction()}
          >

            {props.isLoading ?
              <CircularProgress
                size={24}
                style={{ color: 'white' }}
              />

              :
              props.rightButtonText
            }
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}

BottomBar.propTypes = {
  rightButtonAction: PropTypes.func,
  rightButtonText: PropTypes.string,
  rightButtonHide: PropTypes.bool,
  rightButtonDisable: PropTypes.bool,
  leftButtonAction: PropTypes.func,
  leftButtonHide: PropTypes.bool,
  leftButtonText: PropTypes.string,
  leftButtonDisable: PropTypes.bool,
  isLoading: PropTypes.bool,
  isDrawerOpen: PropTypes.bool

}

BottomBar.defaultProps = {
  rightButtonAction: fn => fn,
  rightButtonText: "Save",
  rightButtonHide: false,
  leftButtonAction: fn => fn,
  leftButtonHide: false,
  leftButtonText: "View",
  isLoading: false,
  isDrawerOpen: false,
  rightButtonDisable: false,
  leftButtonDisable: false

}

export default BottomBar;
